import styled from "styled-components";

export const Wrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 700;
    width: 80%;
    max-height: 95%;
    outline: 0;

    @media (max-width: 1199px) {
        width: 90%;
    }

    @media (max-width: 599px) {
        max-height: 100%;
        height: 100%;
        width: 100%;
    }
`;

export const Backdrop = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 500;
`;

export const StyledModal = styled.div`
    z-index: 100;
    background: white;
    position: relative;
    margin: auto;
    border-radius: 40px;

    @media (max-width: 599px) {
        border-radius: 0;
        height: 100%;
        width: 100%;
    }
`;

export const Header = styled.div`
    border-radius: 40px 40px 0 0;
    display: flex;
    justify-content: space-between;
    background: #2770d8;
    height: 160px;
    padding: 52px 52px 40px 80px;
    gap: 74px;
    justify-content: flex-start;

    @media (max-width: 1199px) {
        gap: 20px;
        height: 140px;
        padding: 40px 20px 20px 40px;
    }

    @media (max-width: 599px) {
        gap: 16px;
        height: 120px;
        padding: 40px 20px 20px 40px;
        border-radius: 0;
    }
`;

export const Logo = styled.img`
    @media (max-width: 1199px) {
        max-width: 35%;
    }
`;

export const HeaderText = styled.div`
    color: white;
    align-self: center;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 140%;

    @media (max-width: 1199px) {
        font-size: 14px;
    }

    @media (max-width: 599px) {
        font-size: 10px;
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 32px;
    right: 32px;
    border: none;
    background: none;
    :hover {
        cursor: pointer;
    }

    @media (max-width: 1199px) {
        top: 20px;
        right: 20px;
    }

    @media (max-width: 599px) {
        top: 16px;
        right: 16px;
    }
`;

export const Content = styled.div`
    max-height: 90%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 50px 80px 50px 80px;

    @media (max-width: 1199px) {
        padding: 16px 24px 16px 24px;
    }
    @media (max-width: 599px) {
        padding: 12px 16px 12px 16px;
    }
`;

export const ContentTitle = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    color: #2770d8;
    margin-bottom: 20px;

    @media (max-width: 1199px) {
        font-size: 24px;
        margin-bottom: 16px;
    }
    @media (max-width: 599px) {
        font-size: 20px;
        margin-bottom: 12px;
    }
`;

export const Solutions = styled.ul`
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 140%;
    color: #2770d8;
    list-style-image: url("${process.env.PUBLIC_URL}/index/solution_bullet.svg");
    margin-bottom: 20px;
    //fix offset
    padding: 20px;
    list-style-type: none;

    @media (max-width: 1199px) {
        font-size: 16px;
        margin-bottom: 16px;
        padding: 10px 20px 10px 20px;
    }
    @media (max-width: 599px) {
        padding: 0px 20px 0px 20px;
    }
`;

export const Solution = styled.li`
    margin: 20px 0;

    @media (max-width: 1199px) {
        margin: 16px 0;
    }
    @media (max-width: 599px) {
        margin: 10px 0;
    }
`;

export const SolutionText = styled.span`
    position: relative;
    left: 20px;
    top: -5px;
    @media (max-width: 1199px) {
        left: 10px;
    }
    @media (max-width: 599px) {
        left: 5px;
    }
`;
